import React, { useCallback, useEffect, useState } from 'react';
import BASE_URL from '../utils/api';

const botao = { padding: '8px 16px', backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 };

const pedir = async (caminho, opcoes) => {
  const res = await fetch(`${BASE_URL}/AceiteProjeto/${caminho}`, opcoes);
  const corpo = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(corpo.mensagem || `Erro ${res.status}`);
  return corpo;
};

// Quadro do formulário do projeto: o que falta para a aprovação do cliente, o link de aceite final e o resultado.
export default function AceiteFinalProjeto({ producaoId, onBaixarPdf, pdfAprovacaoExistente }) {
  const [situacao, setSituacao] = useState(null);
  const [link, setLink] = useState('');
  const [ocupado, setOcupado] = useState(false);

  const carregar = useCallback(async () => {
    try {
      setSituacao(await pedir(`${producaoId}`));
    } catch (err) {
      setSituacao({ erro: err.message });
    }
  }, [producaoId]);

  useEffect(() => { carregar(); }, [carregar]);

  const gerarLink = async () => {
    try {
      setOcupado(true);
      const { link: novo } = await pedir(`${producaoId}/link`, { method: 'POST' });
      setLink(novo);
      try {
        await navigator.clipboard.writeText(novo);
        alert('Link de aprovação copiado.');
      } catch {
        /* sem acesso à área de transferência: o link fica na tela para copiar */
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setOcupado(false);
    }
  };

  const enviarEmail = async () => {
    try {
      setOcupado(true);
      const { mensagem } = await pedir(`${producaoId}/enviar-email`, { method: 'POST' });
      alert(mensagem);
    } catch (err) {
      alert(err.message);
    } finally {
      setOcupado(false);
    }
  };

  if (!situacao) return null;

  return (
    <div style={{ padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0', gridColumn: '1 / -1' }}>
      <h4 style={{ margin: '0 0 8px 0', color: 'rgb(235, 133, 0)', textAlign: 'center' }}>Entregas, Montagens e Aceite Final</h4>
      {situacao.erro && <div style={{ color: '#b00020', fontSize: 13 }}>{situacao.erro}</div>}

      {(situacao.entregas || []).map(e => (
        <div key={e.id} style={{ fontSize: 13, marginBottom: 4 }}>🚚 Entrega #{e.id} em {e.dataEntrega}{e.itensEntregues ? `: ${e.itensEntregues}` : ''}</div>
      ))}
      {(situacao.montagens || []).map(m => (
        <div key={m.id} style={{ fontSize: 13, marginBottom: 4 }}>🔧 Montagem #{m.id} em {m.dataMontagem}{m.descricao ? `: ${m.descricao}` : ''}</div>
      ))}

      {situacao.aceito ? (
        <div style={{ marginTop: 8, padding: 10, background: '#e8f5e9', borderRadius: 6, color: '#2e7d32', fontWeight: 600 }}>
          ✅ Aprovado pelo cliente em {new Date(situacao.dataAceite).toLocaleDateString('pt-BR')}
        </div>
      ) : (situacao.pendencias || []).length > 0 ? (
        <div style={{ marginTop: 8, padding: 10, background: '#fff8e1', borderRadius: 6, fontSize: 13 }}>
          <strong style={{ color: '#b26a00' }}>Para enviar ao cliente, falta:</strong>
          <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
            {situacao.pendencias.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
        </div>
      ) : !situacao.erro && (
        <div style={{ marginTop: 8, textAlign: 'center' }}>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
            O projeto só é finalizado quando o cliente confirma o aceite pelo link. A garantia começa a contar nessa data.
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button type="button" disabled={ocupado} onClick={gerarLink} style={botao}>🔗 Copiar link de aprovação</button>
            <button type="button" disabled={ocupado} onClick={enviarEmail} style={botao}>📧 Enviar link por e-mail</button>
          </div>
          {link && <input readOnly value={link} onFocus={(e) => e.target.select()} style={{ marginTop: 10, width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ddd', boxSizing: 'border-box', fontSize: 12 }} />}
        </div>
      )}

      {pdfAprovacaoExistente && (
        <div onClick={onBaixarPdf} style={{ marginTop: 10, padding: '10px 14px', borderRadius: 6, border: '2px solid #4caf50', background: '#e8f5e9', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
          <span style={{ fontSize: 22 }}>📄</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600, color: '#2e7d32' }}>{pdfAprovacaoExistente.fileName}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Clique para baixar o comprovante de aprovação</div>
          </div>
          <span style={{ fontSize: 20, color: '#2e7d32' }}>⬇</span>
        </div>
      )}
    </div>
  );
}
